import styled, { css } from 'styled-components';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { BORDER_BOX } from 'common';

export default {
  Header: styled.div`
    ${BORDER_BOX}
    ${props => css`direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};`}
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: ${Tokens.SPACING.SPACING_0};
    padding-right: ${props => (props.RTL || props.$rtl || props.rtl) ? Tokens.SPACING.SPACING_24 : Tokens.SPACING.SPACING_16};
    padding-left: ${props => (props.RTL || props.$rtl || props.rtl) ? Tokens.SPACING.SPACING_16 : Tokens.SPACING.SPACING_24};
  `,
  ButtonsContainer: styled.div`
    ${BORDER_BOX}
    align-self: flex-start;
    padding: ${Tokens.SPACING.SPACING_12} ${Tokens.SPACING.SPACING_0};
    & > * {
      margin-left: ${props => (props.RTL || props.$rtl || props.rtl) ? Tokens.SPACING.SPACING_0 : Tokens.SPACING.SPACING_12};
      margin-right: ${props => (props.RTL || props.$rtl || props.rtl) ? Tokens.SPACING.SPACING_12 : Tokens.SPACING.SPACING_0};
    }
  `
};
